<template>
  <div>
    <v-dialog
      :overlay="false"
      fullscreen
      value="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar flat class="card-toolbar-title">
          <v-toolbar-title>Client Document: {{ editedItem.description }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>
        <div>
          <v-card text>
            <v-container fluid grid-list-md>
              <v-form ref="form">
                <v-card-actions>
                  <v-layout row justify-center>
                    <v-flex xs12 sm2>
                      <v-autocomplete
                        id="selectedUserGroup"
                        v-model="selectedUserGroup"
                        :items="userGroups"
                        :filter="userGroupsFilter"
                        :hint="selectedUserGroup.userGroupDesc"
                        :rules="required"
                        required
                        class="required"
                        name="selectedUserGroup"
                        label="Select User Group To Add"
                        return-object
                      >
                        <template v-slot:selection="data">
                          {{ data.item.userGroupName }}
                        </template>
                        <template v-slot:item="data">
                          {{ data.item.userGroupName }} <span class="subheader">{{ data.item.userGroupDesc }}</span>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn
                        tooltip.hover title="Add a User Group to this Document"
                        fab
                        dark
                        color="primary"
                        @click.native="addUserGroup"
                      >
                        <v-icon dark>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-form>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Filter User Groups"
                    single-line
                  />
                  <v-data-table
                    :headers="tableHeaders"
                    :items="editedItemGroups"
                    :search="search"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item="props">
                      <tr>
                        <td class="justify-center">
                          <v-btn tooltip.hover title="Delete User Group from Document" icon class="mx-0" @click="delUserGroup(props.item.userGroupId)">
                            <v-icon color="error">delete</v-icon>
                          </v-btn>
                        </td>
                        <td>{{ props.item.userGroupName }}</td>
                        <td>{{ props.item.userGroupDesc }}</td>
                        <td>{{ props.item.lastModifiedBy }}</td>
                        <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'client-document-groups-table',
  props: {
    editedItem: Object,
    editItemGroups: Array
  },
  data() {
    return {
      editedItemGroups: cloneDeep(this.editItemGroups),
      search: '',
      selectedUserGroup: {},
      required: [
        v => !!v.userGroupId || 'Required'
      ],
      tableHeaders: [
        {
          text: 'Action',
          value: false,
          sortable: false
        },
        {
          text: 'User Groups',
          value: 'userGroupName'
        },
        {
          text: 'User Group Description',
          value: 'userGroupDesc'
        },
        {
          text: 'Created By',
          value: 'lastModifiedBy'
        },
        {
          text: 'Created On',
          value: 'lastModifiedOn'
        }
      ]
    }
  },
  computed: {
    ...mapState('manageUsers', ['userGroups'])
  },
  methods: {
    cloneDeep: cloneDeep,
    ...mapActions('manageClientDocuments', ['addClientDocumentGroup', 'deleteClientDocumentGroup']),
    userGroupsFilter(item, queryText, itemText) {
      const lower = val => val ? val.toLowerCase() : ''
      return lower(item.userGroupName).indexOf(lower(queryText)) > -1 || lower(item.userGroupDesc).indexOf(lower(queryText)) > -1
    },
    addUserGroup() {
      if (this.$refs.form.validate()) {
        this.addClientDocumentGroup({ documentId: this.editedItem.documentId, userGroupId: this.selectedUserGroup.userGroupId }).then(e => this.editedItemGroups = e.data, () => {})
      }
    },
    delUserGroup(userGroupId) {
      this.deleteClientDocumentGroup({ documentId: this.editedItem.documentId, userGroupId: userGroupId }).then(e => this.editedItemGroups = e.data, () => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-text-color {
    color: $color-success;
  }

  .remove-text-color {
    color: $color-danger
  }

  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
